import {
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { Content, Header, Page } from '@backstage/core-components';
import SchoolIcon from '@material-ui/icons/School';
import { FaTools, FaShieldAlt, FaRobot, FaSitemap } from 'react-icons/fa';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    transition: 'box-shadow 0.2s',
    '&:hover': {
      boxShadow: theme.shadows[6],
    },
  },
  cardContent: {
    flexGrow: 1,
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  icon: {
    fontSize: 64,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  cardActions: {
    justifyContent: 'center',
    paddingBottom: theme.spacing(3),
  },
  headerLogo: {
    height: 64,
    marginRight: theme.spacing(2),
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  headerTitle: {
    fontSize: '1.75rem',
    fontWeight: 700,
    lineHeight: 1.2,
    color: 'inherit',
  },
  headerSubtitle: {
    fontSize: '0.9rem',
    opacity: 0.85,
    marginTop: 4,
    fontWeight: 400,
    color: 'inherit',
  },
}));

export const categories = [
  {
    name: 'Formations',
    path: '/domain/academy',
    description: 'Support de formations dispensées et validées',
    Icon: SchoolIcon,
  },
  {
    name: 'Partage de connaissances',
    path: '/domain/knowledge-sharing',
    description:
      'Talks, ateliers, templates et exemples partagés par la communauté',
    Icon: PresentToAllIcon,
  },
  {
    name: 'IA & GenAI',
    path: '/system/ia-resource',
    description: 'Projets, présentations et expérimentations IA & GenAI',
    Icon: FaRobot,
  },
  {
    name: 'Innersource',
    path: '/domain/innersource',
    description: 'Projets partagés et outils internes',
    Icon: FaTools,
  },
  {
    name: 'Coordination Technique',
    path: '/domain/coordination-technique',
    description: 'Outils et instances de coordination technique inter-pôles',
    Icon: FaSitemap,
  },
  {
    name: 'Cyber',
    path: '/system/cyber',
    description: 'Ressources et réglementations Cyber',
    Icon: FaShieldAlt,
  },
];

export const HomePage = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Page themeId="home">
      <Header
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/kaizen-logo.png" alt="Kaizen Solutions" className={classes.headerLogo} />
            <div className={classes.headerText}>
              <span className={classes.headerTitle}>Catalogue Kaizen Solutions</span>
              <span className={classes.headerSubtitle}>Sélectionnez une catégorie pour explorer les projets</span>
            </div>
          </div>
        }
        pageTitleOverride="Catalogue Kaizen Solutions"
      />
      <Content>
        <Grid container spacing={4} justifyContent="center">
          {categories.map(({ name, path, description, Icon }) => (
            <Grid item xs={12} sm={6} md={4} key={path}>
              <Card
                className={classes.card}
                onClick={() => navigate(path, { state: { title: name } })}
                elevation={2}
              >
                <CardContent className={classes.cardContent}>
                  <Icon className={classes.icon} />
                  <Typography variant="h4" gutterBottom>
                    {name}
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    {description}
                  </Typography>
                </CardContent>
                <CardActions className={classes.cardActions}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={e => {
                      e.stopPropagation();
                      navigate(path, { state: { title: name } });
                    }}
                  >
                    Explorer
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Content>
    </Page>
  );
};
